import React from 'react'

function Sliderabout() {
    return (
        <>
        </>
    )
}

export default Sliderabout